import { useState } from 'react';

const Accordion = ({ title, children }) => {
	  const [isOpen, setIsOpen] = useState(true);

	return (
		<div className={`accordion ${isOpen ? 'is-open' : ''}`}>
			<div className={'accordion__header'} onClick={() => setIsOpen(!isOpen)}>
				<h4>
					{title}
				</h4>
				<img
					className="icon"
					src={'./assets/icon--chevron--down.svg'}
					alt="Toggle Accordion"
					title="Toggle Accordion"
				/>
			</div>
			<div className={'accordion__body'}>
				{children}
			</div>
		</div>
	);
};

export default Accordion;
